import styled from 'styled-components';

export const CSSTable = styled.table`
    width: 100%;
`;

export const CSSTableHead = styled.thead`
    font-weight: ${(props) => props.theme.font.weight.bold};
`;
export const CSSTableBody = styled.tbody``;

export const CSSTableTd = styled.td<{ width?: number }>`
    padding: ${(props) => props.theme.space.md}px;
    position: relative;
    min-width: ${(props) => (props.width ? props.width + 'px' : 'auto')};
    max-width: ${(props) => (props.width ? props.width + 'px' : 'auto')};
    vertical-align: top;
`;

export const CSSTableTh = styled.th<{ width?: number }>`
    padding: ${(props) => props.theme.space.md}px;
    position: relative;
    min-width: ${(props) => (props.width ? props.width + 'px' : 'auto')};
    max-width: ${(props) => (props.width ? props.width + 'px' : 'auto')};
    vertical-align: top;
`;

export const CSSTableHeadTdContent = styled.div`
    display: flex;
    align-items: center;
`;
export const CSSTableTdContent = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`;

export const CSSTableTr = styled.tr<{ background: string; color: string }>`
    background-color: ${(props) => props.background};
    color: ${(props) => props.color};
`;

export const CSSTableOverlay = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
`;

export const CSSTableRadius = styled.div<{ borderRadius: number }>`
    position: absolute;
    inset: 0;
    overflow: hidden;
    border-radius: ${(props) => props.borderRadius}px;
`;

export const CSSTableWrapper = styled.div`
    position: absolute;
    inset: 0;
    overflow: auto;
`;

export const CSSEllipsis = styled.div<{ width?: number; line: number }>`
    p:first-child {
        display: -webkit-box;
        -webkit-line-clamp: ${(props) => props.line};
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        width: ${(props) => (props.width ? props.width + 'px' : 'auto')};
    }
    p:not(:first-child) {
        display: none;
    }
`;

export const CSSReadMoreWrapper = styled.div`
    position: relative;
    max-height: 100px;
    overflow: hidden;
`;

export const CSSReadMoreGradient = styled.div<{ backgroundColor: string }>`
    height: 32px;
    background: linear-gradient(0deg, ${(props) => props.backgroundColor} 0%, rgba(255, 255, 255, 0) 100%);
    position: absolute;
    bottom: 0px;
    width: 100%;
    left: 0px;
    right: 0px;
`;
